<template>
    <div>
        <HeaderCentered>
            <template #title>
                <i18n path="login.signup.confirmation.title">
                    <template #email>
                        <span class="email">{{ registeredEmail }}</span>
                    </template>
                </i18n>
            </template>
        </HeaderCentered>
        <OtCardContent class="signup-confirmation">
            <div class="signup-confirmation__text">
                {{ $t('login.signup.confirmation.explanation') }}
            </div>
            <OtButton
                class="ot-button"
                @click="$router.push({name: 'login', query: $route.query})"
                :title="$t('login.signup.confirmation.next.title')"
            >
                {{ $t('login.signup.confirmation.next.text') }}
                <i class="oti oti-arrow-right ot-button-icon--right"/>
            </OtButton>
        </OtCardContent>
    </div>
</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-property-decorator';
import HeaderCentered from '../HeaderCentered.vue';
import OtButton from '../OtButton.vue';

@Component({ components: { HeaderCentered, OtButton } })
export default class PasswordRecoveryConfirmation extends Vue {

    @Prop() registeredEmail!: string;

}
</script>

<style lang="scss" scoped>
.signup-confirmation {
    text-align: center;

    &__text {
        font-weight: 400;
        text-align: center;
        font-size: 16px;
        margin-bottom: var(--ot-spacing-2xl);
        color: var(--ot-color-core-light-foreground-secondary);

    }
}

.email {
    color: var(--ot-color-core-brand);
}
</style>
